import { Footnote } from './Footnote'
import { FootnoteMaker } from './FootnoteMaker'
import { TypedParagraph } from "./TypedParagraph";
import sortBlocks from "./blocksorter/sortBlocks"
console.log('Loaded editorjs-footnotes version 0.0.4-alpha')
export { Footnote, FootnoteMaker, TypedParagraph, sortBlocks }
